import { Spin, Alert } from 'antd'
import Table from '@/components/common/Table'
import SupportingDocumentsForClaimTabOriginalDocumentHook from './SupportingDocumentsForClaimTabOriginalDocument.hook'
const SupportingDocumentsForClaimTabOriginalDocument = () => {
  const { columns, tableData, isLoading, error } =
    SupportingDocumentsForClaimTabOriginalDocumentHook()

  if (error) {
    return (
      <Alert
        message="เกิดข้อผิดพลาด"
        description="ไม่สามารถโหลดข้อมูลรายการเอกสารฉบับจริงได้"
        type="error"
        showIcon
      />
    )
  }

  return (
    <>
      <Spin spinning={isLoading}>
        <Table
          rowKey="id"
          data-testid="original-document-table"
          columns={columns}
          dataSource={tableData}
          loading={isLoading}
          scroll={{ x: 2000 }}
        />
      </Spin>
    </>
  )
}

export default SupportingDocumentsForClaimTabOriginalDocument
